import data from '../websiteVariables.json';
export const readWebsiteVariable = (
  variable: string,
  selectedRegion?: string
): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const variables = data as any;
  let region;
  if (!selectedRegion) {
    if (document.URL.includes('app.ca.')) {
      region = 'ca-central-1';
    } else {
      region = 'us-east-1';
    }

    return variables[region][variable];
  } else {
    return variables[selectedRegion][variable];
  }
};
